import Handlebars from 'handlebars';
import AMApp from '../../global/app';

/**
 * RuecknahmeAussetzungen Module (Plain JS)
 */
export default class RuecknahmeAussetzungen {
  constructor(element, options = {}) {
    this.element = element;
    this.amApp = new AMApp();

    this.settings = {
      routeFondsRuecknahme: AMApp.langGetParam + 'eID=fonds&function=ruecknahme',
      ...options
    };

    const templateEl = document.getElementById('ruecknahmeaussetzungen_template');
    this.rawTemplate = templateEl ? templateEl.innerHTML : '';

    // Das Ziel-Element ist in diesem Fall das Element selbst (id="ruecknahmeaussetzungen")
    this.target = this.element;
    this.statusNoResult = document.querySelector('.ruecknahmeaussetzungen-none');

    this.init();
  }

  init() {
    console.log('### RuecknahmeAussetzungen ###');
    this.getRuecknahmeData();
  }

  /**
   * Get data via Fetch API
   */
  async getRuecknahmeData() {
    // Loader einfügen
    this.target.insertAdjacentHTML('beforebegin', AMApp.LOADING_ANIMATION);

    this.statusIsLoading();

    const url = AMApp.basePath + this.settings.routeFondsRuecknahme;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const result = await response.json();

      if (result) {
        let data = { data: [] };
        if (result.length > 0) {
          data = {
            lastChange: result[0].Datum,
            data: result
          };
        }
        this.renderRuecknahmeTableData(data);
      }
    } catch (error) {
      console.error('error', error);
      this.statusError();
      this.removeLoader();
    }
  }

  /**
   * Render table using Handlebars
   * @param {Object} data
   */
  renderRuecknahmeTableData(data) {
    if (data && this.rawTemplate) {
      this.statusDataFound();
      const template = Handlebars.compile(this.amApp.toHandlebarsDelimiters(this.rawTemplate));
      this.target.innerHTML = template(data);

      // Tablesaw Re-Init für Responsive Tabellen
      if (window.innerWidth <= AMApp.CONSTANTS.BREAKPOINT.LG) {
        setTimeout(() => {
          if (window.Tablesaw) {
            // window.Tablesaw.init();
          }
        }, 250);
      }

      if (data.data.length === 0) {
        this.statusNoData();
      }
    } else {
      this.statusNoData();
    }
  }

  statusIsLoading() {
    if (this.statusNoResult) {
      this.statusNoResult.classList.add('d-none');
    }

    if (window.innerWidth <= AMApp.CONSTANTS.BREAKPOINT.LG) {
      const loader = document.querySelector('.loader');
      if (loader) {
        window.scrollTo({
          top: loader.getBoundingClientRect().top + window.scrollY,
          behavior: 'smooth'
        });
      }
    }
  }

  statusNoData() {
    if (this.statusNoResult) {
      this.statusNoResult.classList.remove('d-none');
    }
    this.removeLoader();
  }

  statusDataFound() {
    // Im Original wurde hier d-none false gesetzt,
    // was untypisch für "Data Found" ist, aber wir behalten die Logik bei:
    if (this.statusNoResult) {
      this.statusNoResult.classList.remove('d-none');
    }
    this.removeLoader();
  }

  statusError() {
    if (this.statusNoResult) {
      this.statusNoResult.classList.remove('d-none');
    }
  }

  removeLoader() {
    document.querySelectorAll('.loader').forEach(loader => loader.remove());
  }
}